module.exports = __webpack_public_path__ + "img/4.3275a176.jpg";